import { API_REQUEST, GET_PROFILE_OVERVIEW, SAVE_RESULT, GET_PROFILE_ATTRIBUTES, RESET_GET_PROFILE_ATTRIBUTES } from "../../actionTypes/actionsTypes";
import { AppAction, AsyncActionType, LocalAction } from "../../types";

export const getProfileOverview = (profileID: number | string, wac?: string): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/profile-overview/${profileID}/${wac ? wac : "internal"}`,
    next: GET_PROFILE_OVERVIEW,
    method: 'GET',
    authorization: true
  }
});

export const getProfileAttributes = (profileType: string, snapshotId: number | string, target: AsyncActionType = GET_PROFILE_ATTRIBUTES): AppAction => {
  return {
    type: API_REQUEST,
    payload: {
      url: `/income/profile/${profileType}/${snapshotId}/get-profile-attributes`,
      next: target,
      method: 'GET',
      authorization: true
    }
  }
}

export const resetGetProfileAttributes = (): LocalAction => ({
  type: RESET_GET_PROFILE_ATTRIBUTES
})

export const putProfileAttributes = (profileType: string, snapshotId: number | string, payload: Record<string, unknown>): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/profile/${profileType}/${snapshotId}/update-profile-attributes`,
    data: {
      ...payload
    },
    next: SAVE_RESULT,
    method: 'PUT',
    authorization: true
  }
})
